import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["icon", "text"]
  static values = { content: String }

  copy(event) {
    if (event) event.preventDefault()

    const textToCopy = this.contentValue || this.element.dataset.clipboardContent

    if (!textToCopy) return

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.showCopiedState()
    }).catch(err => {
      console.error('Error copying text:', err)
    })
  }

  showCopiedState() {
    if (this.timeout) clearTimeout(this.timeout)

    if (this.hasIconTarget) {
      this.iconTarget.textContent = 'check'
      this.iconTarget.classList.add('text-emerald-500', 'scale-110', 'transition-transform')
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = '¡Copiado!'
      this.textTarget.classList.add('text-emerald-500')
    }

    this.element.classList.add('border-emerald-500/50', 'bg-emerald-500/10')

    this.timeout = setTimeout(() => {
      if (this.hasIconTarget) {
        this.iconTarget.textContent = 'content_copy'
        this.iconTarget.classList.remove('text-emerald-500', 'scale-110', 'transition-transform')
      }

      if (this.hasTextTarget) {
        this.textTarget.textContent = 'Copiar enlace'
        this.textTarget.classList.remove('text-emerald-500')
      }

      this.element.classList.remove('border-emerald-500/50', 'bg-emerald-500/10')
    }, 2000)
  }
}
